<template>
  <svg
    id="contour_copia"
    data-name="contour copia"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
  >
    
    <title>63_checkList-LIGHT</title>
    <path fill="#679940" class="cls-1" d="M60,26H16a2,2,0,0,0,0,4H60a2,2,0,0,0,0-4Z" />
    <path fill="#679940" class="cls-1" d="M60,46H16a2,2,0,0,0,0,4H60a2,2,0,0,0,0-4Z" />
    <path fill="#679940" class="cls-1" d="M60,16H16a2,2,0,0,0,0,4H60a2,2,0,0,0,0-4Z" />
    <path fill="#679940" class="cls-1" d="M16,10H60a2,2,0,0,0,0-4H16a2,2,0,0,0,0,4Z" />
    <path fill="#679940" class="cls-1" d="M60,36H16a2,2,0,0,0,0,4H60a2,2,0,0,0,0-4Z" />
    <path fill="#679940" class="cls-1" d="M60,56H16a2,2,0,0,0,0,4H60a2,2,0,0,0,0-4Z" />
    <rect fill="#679940" class="cls-1" x="4" y="4" width="8" height="8" rx="2" />
    <rect fill="#679940" class="cls-1" x="4" y="24" width="8" height="8" rx="2" />
    <rect fill="#679940" class="cls-1" x="4" y="44" width="8" height="8" rx="2" />
  </svg>
</template>

<script>
export default {
  name: "ReportIcon"
};
</script>


// WEBPACK FOOTER //
// src/icons/ReportIcon.vue